// extracted by mini-css-extract-plugin
export default {"lineBox":"MiniProjectLine_lineBox__vVBjb","line":"MiniProjectLine_line__z2nd2"};